import React from 'react'
import CreateAccountPage from '../../components/Merchant/MerchantOnboarding/CreateAccount';

const CreateAccount = () => {
  return (
    <CreateAccountPage />
  )
}

export default CreateAccount;